<template>
  <div class="multi-select">
    <span class="multi-select-dsc">环境切换</span>
    <kye-select class="multi-select-system" @clear="clearSystem" @change="changeSystem" v-model="systemName" placeholder="请选择产品线">
      <kye-option
        v-for="item in systemList"
        :key="item.productLine"
        :label="item.productLine"
        :value="item.productLine"
      >
      </kye-option>
    </kye-select>
    <kye-select class="multi-select-version" @clear="clearVersion" :disabled="isDisabledVersion" v-model="versionId" placeholder="请选择环境" @change="changeVersion">
      <kye-option
        v-for="item in envList"
        :key="item.envId"
        :label="item.envName"
        :value="item.envId"
      >
      </kye-option>
    </kye-select>
  </div>
</template>
<script>
  import { setMultiModuleData, MULTISESSIONKEY } from '@/layout/utils'
  export default {
    data() {
      return {
        systemList: [],
        systemName: '默认',
        envList: [],
        versionId: ''
      }
    },
    mounted() {
      this.getListInfo()
    },
    computed: {
      isDisabledVersion() {
        return this.systemName === '默认'
      }
    },
    methods: {
      // 获取环境下拉数据
      async getListInfo() {
        try {
          const defalutVsersion = {
            productLine: '默认',
            envList: []
          }
          const data = await this.$http('fmk.virtualEnv.list', {
            clientType: 10
          }, { appkey: '55111' })
          this.systemList = [defalutVsersion, ...data]
          this.initMultiData()
        } catch (error) {
          console.log('error', error)
        }
      },
      // 初始化默认数据
      initMultiData() {
        try {
          const multiSessionStr = sessionStorage.getItem('ERPMULTIMODULE')
          if (multiSessionStr) {
            const multiSessionData = JSON.parse(multiSessionStr)
            this.systemName = multiSessionData.systemName
            this.envList = this.systemList.find(i => i.productLine === this.systemName).envList
            const versionData = this.envList && this.envList.find(i => i.envId === multiSessionData.envId)
            if (versionData) {
              this.versionId = multiSessionData.envId
            } else {
              this.versionId = ''
              this.clearVersion()
            }
          }
        } catch (err) {
          console.error('initMultiData', err)
        }
      },
      // 选择环境，存储session
      changeVersion(val) {
        try {
          const selectVersion = this.envList.find(i => i.envId === val)
          const versionModule = {
            systemName: this.systemName, // 系统名称: 基础服务
            systemCode: selectVersion.module, // 前端产品线: sys、crm、tms
            version: selectVersion.resourcePath, // 多版本远程包夹子: remote-module-sys1
            envId: selectVersion.envId, // 多版本环境id
            envName: selectVersion.envName // 多版本环境名称
          }
          setMultiModuleData(versionModule)
          window.__intercept__ = 0
          location.reload()
        } catch (err) {
          console.error('changeVersion', err)
        }
      },
      clearSystem() {
        this.versionId = ''
        this.envList = []
      },
      clearVersion() {
        sessionStorage.removeItem(MULTISESSIONKEY)
      },
      changeSystem(val) {
        sessionStorage.removeItem(MULTISESSIONKEY)
        if (!val) {
          window.__intercept__ = 0
          location.reload()
          return
        }
        const selectSystem = this.systemList.find(i => i.productLine === val)
        this.envList = selectSystem.envList
        this.versionId = ''
        if (val === '默认') {
          window.__intercept__ = 0
          location.reload()
        }
      }
    }
  }
</script>
<style lang="scss" scoped>
.multi-select {
  position: absolute;
  top: 0;
  right: 120px;
  width: 340px;
  height: 36px;
  // background: red;
  display: flex;
  align-items: center;
  &-dsc {
    color: #fff;
  }
  &-system {
    width: 120px;
    margin-left: 10px;
  }
  &-version {
    width: 140px;
    margin-left: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/layout/components/multi-module-select.vue